<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" v-if="see_all_stat"><!-- ROW 1-->
    <div class="vx-row">
      <div @click="go_to_paths(0)" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="TruckIcon"
          :statistic="paths"
          statisticTitle="Trajets" />
      </div>
      <div @click="go_to_paths(1)" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="TruckIcon"
          :statistic="activePaths"
          statisticTitle="Trajets en cours"
          color="success" />
      </div>
      <div @click="go_to_producers()" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="UsersIcon"
          :statistic="producers"
          statisticTitle="Producteurs"
          color="warning" />
      </div>
      <div @click="go_to_stores()" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="BoxIcon"
          :statistic="stores"
          statisticTitle="Magasins"
          color="danger" />
      </div>
      <div @click="go_to_guardians(1)" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="UsersIcon"
          :statistic="guardians"
          statisticTitle="Gardiens"
          color="success" />
      </div>
      <div @click="go_to_cooperatives(1)" class="cursor-pointer vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base "
          icon="GlobeIcon"
          :statistic="cooperatives"
          statisticTitle="Coopératives"
          color="warning" />
      </div>
    </div>

    <div v-if="false" class="vx-row">

      <!-- CARD 1: CONGRATS -->
      <div v-if="false" class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                    <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Congratulations {{ checkpointReward.userName }},</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done <strong>{{ checkpointReward.progress }}</strong> more sales today. Check your new badge in your profile.</p>
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div v-if="false" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" statistic="92.6k" statisticTitle="Subscribers Gained" :chartData="subscribersGained.series" type='area'></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div v-if="false" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ShoppingBagIcon" statistic="97.5K" statisticTitle="Orders Received" :chartData="ordersRecevied.series" color='warning' type='area'></statistics-card-line>
      </div>
    </div>

    <div v-if="false" class="vx-row">

      <!-- CARD 4: SESSION -->
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">

            <!-- LEFT COL -->
            <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between" v-if="salesBarSession.analyticsData">
              <div>
                <h2 class="mb-1 font-bold">{{ salesBarSession.analyticsData.session | k_formatter }}</h2>
                <span class="font-medium">Avg Sessions</span>

                <!-- Previous Data Comparison -->
                <p class="mt-2 text-xl font-medium">
                  <span :class="salesBarSession.analyticsData.comparison.result >= 0 ? 'text-success' : 'text-danger'">
                    <span v-if="salesBarSession.analyticsData.comparison.result > 0">+</span>
                    <span>{{ salesBarSession.analyticsData.comparison.result }}</span>
                  </span>
                  <span> vs </span>
                  <span>{{ salesBarSession.analyticsData.comparison.str }}</span>
                </p>
              </div>
              <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full lg:mt-0 mt-4">View Details</vs-button>
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
              <change-time-duration-dropdown class="self-end" />
              <vue-apex-charts type=bar height=200 :options="analyticsData.salesBar.chartOptions" :series="salesBarSession.series" v-if="salesBarSession.series" />
            </div>

          </div>
          <vs-divider class="my-6"></vs-divider>
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-3">
              <p>Goal: $100000</p>
              <vs-progress class="block mt-1" :percent="50" color="primary"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Users: 100K</p>
              <vs-progress class="block mt-1" :percent="60" color="warning"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Retention: 90%</p>
              <vs-progress class="block mt-1" :percent="70" color="danger"></vs-progress>
            </div>
            <div class="vx-col w-1/2 mb-3">
              <p>Duration: 1yr</p>
              <vs-progress class="block mt-1" :percent="90" color="success"></vs-progress>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- CARD 5: SUPPORT TRACKER -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
          <vx-card title="Support Tracker">
              <!-- CARD ACTION -->
              <template slot="actions">
                  <change-time-duration-dropdown />
              </template>

              <div slot="no-body" v-if="supportTracker.analyticsData">
                  <div class="vx-row text-center">

                      <!-- Open Tickets Heading -->
                      <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                          <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                              <h1 class="font-bold text-5xl">{{ supportTracker.analyticsData.openTickets }}</h1>
                              <small>Tickets</small>
                          </div>
                      </div>

                      <!-- Chart -->
                      <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                          <vue-apex-charts type=radialBar height=385 :options="analyticsData.supportTrackerRadialBar.chartOptions" :series="supportTracker.series" />
                      </div>
                  </div>

                  <!-- Support Tracker Meta Data -->
                  <div class="flex flex-row justify-between px-8 pb-4">
                      <p class="text-center" v-for="(val, key) in supportTracker.analyticsData.meta" :key="key">
                        <span class="block">{{ key }}</span>
                        <span class="text-2xl font-semibold">{{ val }}</span>
                      </p>
                  </div>
              </div>
          </vx-card>
      </div>
    </div>

    <div v-if="desired" class="vx-row">
      <div class="vx-col w-full lg:w-2/3 lg:mt-0 mb-base">
        <vx-card title="Prix moyen achat par agent au kilo">
          <vue-apex-charts type=bar height=266 :options="analyticsData.clientRetentionBar_third.chartOptions" :series="clientRetentionBar_third.series" />
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <div class="vx-col w-full lg:w-1/3 mt-0 mb-base">
          <vx-card title="Déviance des trajets">
              <template slot="actions">
                <feather-icon @click="go_to_paths(2)" icon="TruckIcon" svgClasses="w-6 h-6" class="p-3 inline-flex rounded-full" :class="'text-success'"></feather-icon>
              </template>

              <!-- CHART -->
              <template slot="no-body">
                  <div class="mt-0 mb-5">
                      <vue-apex-charts type=radialBar height=240 :options="analyticsData.goalOverviewRadialBar.chartOptions" :series="goalOverview.series" />
                  </div>
              </template>

              <!-- DATA -->
              <div class="flex justify-between text-center" slot="no-body-bottom">
                  <div @click="go_to_paths(2)" class="cursor-pointer w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
                      <p class="mt-4">Trajets avec déviance</p>
                      <p class="mb-4 text-3xl font-semibold">{{inProgress}}</p>
                  </div>
                  <div class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0">
                      <p class="mt-4">Trajets sans déviance</p>
                      <p class="mb-4 text-3xl font-semibold">{{completed}}</p>
                  </div>
              </div>
          </vx-card>
      </div>
    </div>

    <div v-if="desired" class="vx-row">
      <div class="vx-col w-full md:w-1/2  mb-base">
        <vx-card title="Total des frais engagés par agent">
          <vue-apex-charts type=bar height=266 :options="analyticsData.clientRetentionBar.chartOptions" :series="clientRetentionBar.series" />
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2  mb-base">
        <vx-card title="Quantité achetée par agent au kilo">
          <vue-apex-charts type=bar height=266 :options="analyticsData.clientRetentionBar_second.chartOptions" :series="clientRetentionBar_second.series" />
        </vx-card>
      </div>
    </div>

    <div v-if="desired" class="vx-row">
      <!-- LINE CHART -->
      <div class="vx-col w-full lg:w-2/3 mb-base">
          <vx-card title="Total des frais engagés par type de frais et par zone">

              <template slot="actions">
                  <v-select :reduce="rep => rep.id" class="w-full wr-0" label="name" v-model="prefecture" :options="prefectures"></v-select>
              </template>

              <div slot="no-body" class="p-6 pb-0">

                  <div class="flex" v-if="revenueComparisonLine.analyticsData">
                      <!-- <div class="mr-6">
                          <p class="mb-1 font-semibold">This Month</p>
                          <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.thisMonth.toLocaleString() }}</p>
                      </div>
                      <div>
                          <p class="mb-1 font-semibold">Last Month</p>
                          <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.lastMonth.toLocaleString() }}</p>
                      </div> -->
                  </div>

                  <vue-apex-charts
                    type=line
                    height=266
                    :options="analyticsData.revenueComparisonLine.chartOptions"
                    :series="revenueComparisonLine.series" />
              </div>
          </vx-card>
      </div>

      <!-- CUSTOMERS CHART -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Stock par magasin et par colis">
              <!-- SLOT = ACTIONS -->
              <template slot="actions">
                <div class="vx-row">
                  <vs-list>
                    <vs-list-item icon-pack="feather" icon="icon-check" title="Magasin: ">
                      <v-select :reduce="rep => rep.id" class="w-full wr-0" label="name" v-model="selected_stockStore" :options="stockStores"></v-select>
                    </vs-list-item>
                  </vs-list>
                </div>
              </template>

              <div slot="no-body">
                  <!-- CHART -->
                  <vue-apex-charts type=pie height=345 class="mt-10 mb-10" :options="analyticsData.customersPie_second.chartOptions" :series="customersData_second.series" />

                  <!-- CHART DATA -->
                  <ul class="mb-1">
                      <li v-for="customerData in customersData_second.analyticsData" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                          <span class="flex items-center">
                              <span class="inline-block h-3 w-3 rounded-full mr-2" :style="'background-color: ' + customerData.color"></span>
                              <span class="font-semibold">{{ customerData.customerType }}</span>
                          </span>
                          <span>{{ customerData.counts }}</span>
                      </li>
                  </ul>
              </div>

          </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
let base_self = this
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from "@/components/timeline/VxTimeline"
analyticsData.customersPie_second = JSON.parse(JSON.stringify(analyticsData.customersPie))
analyticsData.customersPie_third = JSON.parse(JSON.stringify(analyticsData.customersPie))
analyticsData.clientRetentionBar.chartOptions.plotOptions.bar.columnWidth = "50%"

// analyticsData.revenueComparisonLine.chartOptions.colors = ["#F97794"]

const colorss = [
  { two: '#9bbb00' },
  { two: '#28C76F' },
  { two: '#EA5455' },
  { two: '#FF9F43' },
  { two: '#7961F9' },
  { two: '#9C27B0' },
  { two: '#E91E63' },
  { two: '#F48FB1' },
  { two: '#2196F3' },
  { two: '#FF8A80' },
  { two: '#4CAF50' },
  { two: '#009688' },
  { two: '#FFC107' },
  { two: '#00BFA5' },
  { two: '#FF6F00' },
  { two: '#E64A19' },
  { two: '#FB8C00' },
  { two: '#3E2723' },
  { two: '#455A64' },
  { two: '#9E9E9E' },
  { two: '#000000' },
  { two: '#558B2F' },
  { two: '#33691E' },
  { two: '#B71C1C' },
  { two: '#039BE5' },
  { two: '#388E3C' },
  { two: '#FF8A65' },
  { two: '#90A4AE' },
]


let see_all_stat = true

if (localStorage.getItem('response_data_user_role') === 'agent') {
  see_all_stat = false
}

export default {
    data() {
        return {
            prefecture: '',
            prefectures: [],
            seriesGeneralGeneral: [],
            zonesFeesObkect: {},
            revenueComparisonLine: {},
            completed: 0,
            inProgress: 0,
            options: {
              chart: {
                id: 'vuechart-example'
              },
              xaxis: {
                categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
              }
            },
            series: [{
              name: 'series-1',
              data: [30, 40, 45, 50, 49, 60, 70, 91]
            }],

            see_all_stat: see_all_stat,
            store_general: {},
            selected_stockStore: '',
            stockStores: [],
            paths: 0,
            producers: 0,
            stores: 0,
            guardians: 0,
            cooperatives: 0,
            activePaths: 0,
            desired: false,
            color_index: colorss.length,
            color: colorss,
            goalOverview: {},
            dashboard: {},
            checkpointReward: {},
            subscribersGained: {},
            ordersRecevied: {},
            salesBarSession: {},
            supportTracker: {},
            productsOrder: {},
            customersData: {},
            customersData_second: {},
            customersData_third: {},
            salesRadar: {},
            clientRetentionBar: {},
            clientRetentionBar_second: {},
            clientRetentionBar_third: {},

            timelineData: [
              {
                color: "primary",
                icon: "PlusIcon",
                title: "Client Meeting",
                desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
                time: "25 mins Ago"
              },
              {
                color: "warning",
                icon: "MailIcon",
                title: "Email Newsletter",
                desc: "Cupcake gummi bears soufflé caramels candy",
                time: "15 Days Ago"
              },
              {
                color: "danger",
                icon: "UsersIcon",
                title: "Plan Webinar",
                desc: "Candy ice cream cake. Halvah gummi bears",
                time: "20 days ago"
              },
              {
                color: "success",
                icon: "LayoutIcon",
                title: "Launch Website",
                desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
                time: "25 days ago"
              },
              {
                color: "primary",
                icon: "TvIcon",
                title: "Marketing",
                desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
                time: "28 days ago"
              }
            ],


            analyticsData: analyticsData,
            dispatchedOrders: [],
        }
    },
    components: {
        VueApexCharts,
        StatisticsCardLine,
        ChangeTimeDurationDropdown,
        VxTimeline
    },
    methods: {
      go_to_producers () {
        base_self.$router.push(`/manage_cooperatives/producers`).catch(() => {})
      },
      go_to_stores () {
        base_self.$router.push(`/manage_store/store`).catch(() => {})
      },
      go_to_guardians () {
        base_self.$router.push(`/manage_store/guardian`).catch(() => {})
      },
      go_to_cooperatives () {
        base_self.$router.push(`/manage_cooperatives/cooperatives`).catch(() => {})
      },
      go_to_paths (id) {
        base_self.$router.push(`/manage_paths/paths/${id}`).catch(() => {})
      },
      getIndex () {
        let color_index = 0

        if (base_self.color_index + 1 < base_self.color.length) {
          color_index = base_self.color_index + 1
        }
        base_self.color_index = color_index

        return base_self.color[color_index]
      },
      getDashboard() {
        base_self.$store.state.dashboard({})
          .then((response) => {

            base_self.paths = response.data.paths
            base_self.producers = response.data.producers
            base_self.stores = response.data.stores
            base_self.guardians = response.data.guardians
            base_self.cooperatives = response.data.cooperatives
            base_self.activePaths = response.data.activePaths
            
            base_self.zonesFees(response.data.zonesFees)
            base_self.pathWithAgainstWeighting(response.data.pathWithAgainstWeighting, response.data.paths)
            base_self.agentFees(response.data.agentFees)
            base_self.agentAverageCost(response.data.agentAverageCost)
            base_self.quantityAchatAgent(response.data.quantityAchatAgent)
            base_self.stockInstores(response.data.stockInstores)
          })
          .catch((error) => { 
            console.log('error: ', error)
          });
      },
      zonesFees(zonesFees) {
        let zonesFeesObkect = {}
        let labels = []
        let series = []
        let index111 = 0

        let length = zonesFees.feeTypes.length
        let length1 = zonesFees.prefectures.length
        for (let i = 0; i < length; i++) {
          labels.push(zonesFees.feeTypes[i].name)
        }

        for (let j = 0; j < length1; j++) {
          let item1 = zonesFees.prefectures[j]
          let data = []
          for (let i = 0; i < length; i++) {
            let item = zonesFees.feeTypes[i]
            data.push(zonesFees[item1.id][item.id])
          }

          series.push({
            data: data,
            name: item1.name
          })
          zonesFeesObkect[item1.id] = j
          if (j === 0) {
            index111 = item1.id
          }
        }
        
        base_self.revenueComparisonLine = {
          analyticsData: {
            thisMonth: 86589
          },
          series: [series[0]]
        }
        base_self.analyticsData.revenueComparisonLine.chartOptions.xaxis.categories = labels

        // base_self.revenueComparisonLine = JSON.parse(JSON.stringify(base_self.revenueComparisonLine))
        base_self.seriesGeneralGeneral = series
        base_self.zonesFeesObkect = zonesFeesObkect
        base_self.prefectures = zonesFees.prefectures
        base_self.prefecture = index111
      },
      pathWithAgainstWeighting(pathWithAgainstWeighting, paths) {
        base_self.completed = paths - pathWithAgainstWeighting.length
        base_self.inProgress = pathWithAgainstWeighting.length

        base_self.goalOverview = {
          analyticsData: {
            completed: base_self.completed,
            inProgress: base_self.inProgress
          },
          series: [(base_self.inProgress * 100 / (paths ? paths : 1))]
        }
      },
      stockInstores(stockInstore) {
        let length = stockInstore.packagings.length
        let length_1 = stockInstore.stockStores.length

        let store_general = {}

        for (let j = 0; j < length_1; j++) {
          let item_1 = stockInstore.stockStores[j]
          // _second
          let customersData = {
            analyticsData: [],
            series: []
          }
          // trajet en cours - stock par maguasin - 
          let colors = []
          let labels = []

          for (let i = 0; i < length; i++) {
            let item = stockInstore.packagings[i]
            let color = base_self.getIndex()

            customersData.analyticsData.push({
              color: color.two,
              counts: new Intl.NumberFormat('de-DE').format(stockInstore[item_1.id][item.id]),
              customerType: item.name
            })

            customersData.series.push(stockInstore[item_1.id][item.id])

            labels.push(item.name)

            colors.push(color.two)
          }

          store_general[item_1.id] = {
            customersData,
            colors,
            labels
          }
        }

        base_self.store_general = store_general
        base_self.stockStores = JSON.parse(JSON.stringify(stockInstore.stockStores))
        base_self.selected_stockStore = stockInstore.stockStores[0].id
        base_self.desired = true
      },
      agentFees(agentFees) {
        let customersData = {
          analyticsData: [],
          series: []
        }
        // trajet en cours - stock par maguasin - 
        let labels = []

        let length = agentFees.agents.length
        for (let i = 0; i < length; i++) {
          let item = agentFees.agents[i]
          customersData.series.push(agentFees[item.id])
          labels.push(item.full_name)
        }

        base_self.clientRetentionBar = {
          series: [
            {
              data: customersData.series,
              name: "Frais engagés"
            }
          ]
        }
        // const color = base_self.getIndex()
        const color = base_self.getIndex()
        base_self.analyticsData.clientRetentionBar.chartOptions.colors = [color.two]
        base_self.analyticsData.clientRetentionBar.chartOptions.xaxis.categories = labels

        base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))

        base_self.desired = true
      },
      agentAverageCost(agentAverageCost) {
        let customersData = {
          analyticsData: [],
          series: []
        }
        // trajet en cours - stock par maguasin - 
        let labels = []

        let length = agentAverageCost.agents.length
        for (let i = 0; i < length; i++) {
          let item = agentAverageCost.agents[i]
          customersData.series.push(agentAverageCost[item.id])
          labels.push(item.full_name)
        }

        base_self.clientRetentionBar_third = {
          series: [
            {
              data: customersData.series,
              name: "Frais engagés"
            }
          ]
        }
        // const color = base_self.getIndex()
        const color = base_self.getIndex()
        base_self.analyticsData.clientRetentionBar_third = JSON.parse(JSON.stringify(base_self.analyticsData.clientRetentionBar))
        base_self.analyticsData.clientRetentionBar_third.chartOptions.colors = [color.two]
        base_self.analyticsData.clientRetentionBar_third.chartOptions.xaxis.categories = labels

        base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))

        base_self.desired = true
      },
      quantityAchatAgent(quantityAchatAgent) {
        let customersData = {
          analyticsData: [],
          series: []
        }
        // trajet en cours - stock par maguasin - 
        let labels = []

        let length = quantityAchatAgent.agents.length
        for (let i = 0; i < length; i++) {
          let item = quantityAchatAgent.agents[i]
          customersData.series.push(quantityAchatAgent[item.id])
          labels.push(item.full_name)
        }

        base_self.clientRetentionBar_second = {
          series: [
            {
              data: customersData.series,
              name: "Frais engagés"
            }
          ]
        }
        // const color = base_self.getIndex()
        const color = base_self.getIndex()
        base_self.analyticsData.clientRetentionBar_second = JSON.parse(JSON.stringify(base_self.analyticsData.clientRetentionBar))
        base_self.analyticsData.clientRetentionBar_second.chartOptions.colors = [color.two]
        base_self.analyticsData.clientRetentionBar_second.chartOptions.xaxis.categories = labels

        base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))

        base_self.desired = true
      }
    },
    watch: {
      prefecture (value) {
        base_self.revenueComparisonLine.series = [base_self.seriesGeneralGeneral[base_self.zonesFeesObkect[value]]]
      },
      selected_stockStore (value) {
        let item = base_self.store_general[value]

        base_self.analyticsData.customersPie_second.chartOptions.colors = item.colors
        base_self.analyticsData.customersPie_second.chartOptions.labels = item.labels
        base_self.analyticsData.customersPie_second.chartOptions.fill = {
          gradient: {
            gradientToColors: item.colors
          }
        }


        base_self.analyticsData = JSON.parse(JSON.stringify(base_self.analyticsData))
        base_self.customersData_second = JSON.parse(JSON.stringify(item.customersData))
      }
    },
    created() {
      base_self = this
      base_self.getDashboard()
    }
}
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user{
    position: relative;
    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
</style>
